import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect } from '../FormInputs';
import Select from 'react-select';
import type { NarrativeFormData } from '../Forms/types';
import { useStore } from '@tanstack/react-form';
interface DefaultSortingSubgroupProps {
  form: any;
}

export const DefaultSortingSubgroup: React.FC<DefaultSortingSubgroupProps> = ({ form }) => {
  const { t } = useTranslation();

  const defaultSorting = useStore(form.store, (state: any) => state.values.defaultSorting);

  const sortingMenu = [
    { label: t('Rating'), value: 'rating' },
    { label: t('Recency'), value: 'recency' },
    { label: t('Event first seen'), value: 'first_message_date' },
    { label: t('Event last update'), value: 'last_message_date' },
    { label: t('Publications count'), value: 'messages_count' },
  ];

  const sortingOrder = [
    { label: t('Ascending order (A-Z)'), value: true },
    { label: t('Descending order (Z-A)'), value: false },
  ];

  return (
    <div className="form-element-group">
      <div className="form-element">
        <label>{t('Sort by')}</label>
        <form.Field
          name="defaultSorting"
          children={(field: any) => (
            <Select
              options={sortingMenu}
              name="defaultSorting.fieldName"
              value={sortingMenu.find((option) => option.value === defaultSorting.fieldName) || null}
              onChange={(selectedOption) => {
                form.setFieldValue('defaultSorting.fieldName', selectedOption?.value);
              }}
              placeholder={t('Select option')}
              isClearable
            />
              

          )}
        />
      </div>

      <div className="form-element">
        <label>{t('Sorting order')}</label>
        <form.Field
          name="defaultSorting"
          children={(field: any) => (
            <Select
              options={sortingOrder}
              name="defaultSorting.isAscending"
              value={sortingOrder.find((option) => option.value === defaultSorting.isAscending) || null}
              onChange={(selectedOption) => {
                form.setFieldValue('defaultSorting.isAscending', selectedOption?.value);
              }}
              placeholder={t('Select option')}
              isClearable
            />
          )}
        />
      </div>
    </div>
  );
};